package com.tovtalk.utils.config

import kotlinx.browser.localStorage
import kotlinx.browser.window

actual fun isFontDebugEnabled(): Boolean {
    if (localStorage.getItem("tovtalk_debug_font") == "1") return true
    return window.location.search.contains("debug_font=1")
}
